var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.66667C16.4602 6.66667 16.8333 7.03976 16.8333 7.5V15.488L19.5776 12.7438C19.903 12.4183 20.4306 12.4183 20.7561 12.7438C21.0815 13.0692 21.0815 13.5968 20.7561 13.9223L16.599 18.0794C16.4475 18.236 16.2351 18.3333 16 18.3333C15.7612 18.3333 15.5459 18.2329 15.394 18.072L11.2442 13.9223C10.9188 13.5968 10.9188 13.0692 11.2442 12.7438C11.5697 12.4183 12.0973 12.4183 12.4228 12.7438L15.1667 15.4877V7.5C15.1667 7.03976 15.5398 6.66667 16 6.66667Z",
    fill: "#006DC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 17.5C9.33333 17.0398 8.96024 16.6667 8.5 16.6667C8.03976 16.6667 7.66667 17.0398 7.66667 17.5V20.8333C7.66667 21.4964 7.93006 22.1323 8.3989 22.6011C8.86774 23.0699 9.50362 23.3333 10.1667 23.3333H21.8333C22.4964 23.3333 23.1323 23.0699 23.6011 22.6011C24.0699 22.1323 24.3333 21.4964 24.3333 20.8333V17.5C24.3333 17.0398 23.9602 16.6667 23.5 16.6667C23.0398 16.6667 22.6667 17.0398 22.6667 17.5V20.8333C22.6667 21.0543 22.5789 21.2663 22.4226 21.4226C22.2663 21.5789 22.0543 21.6667 21.8333 21.6667H10.1667C9.94565 21.6667 9.73369 21.5789 9.57741 21.4226C9.42113 21.2663 9.33333 21.0543 9.33333 20.8333V17.5Z",
    fill: "#006DC9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16Z",
    fill: "#006DC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCircle);
export default __webpack_public_path__ + "static/media/download-circle.024cd881abfec6b9ceea4a038081ddeb.svg";
export { ForwardRef as ReactComponent };